import type { ReactNode } from "react";
import type { ScheduleProposalResponse } from "../../types/gigTypes";
import GigRequestMessagesPanel from "../messages/GigRequestMessagesPanel";
import Modal from "../ui/Modal/Modal";

type GigRequestConversationModalProps = {
  isOpen: boolean;
  onClose: () => void;
  title: ReactNode;
  role: "teen" | "adult";
  requestId: string;
  participantLabel: string;
  perspective: "teen" | "adult";
  proposals?: ScheduleProposalResponse[] | null;
  timeZone?: string | null;
  summary?: ReactNode;
  messagesDescription?: string;
  emptyThreadMessage?: string;
  scheduleProposalContent?: ReactNode;
  composerSecondaryAction?: ReactNode;
  allowContactInfo?: boolean;
};

const GigRequestConversationModal = ({
  isOpen,
  onClose,
  title,
  role,
  requestId,
  participantLabel,
  perspective,
  proposals,
  timeZone,
  summary,
  messagesDescription,
  emptyThreadMessage,
  scheduleProposalContent,
  composerSecondaryAction,
  allowContactInfo = false,
}: GigRequestConversationModalProps) => (
  <Modal
    isOpen={isOpen}
    onClose={onClose}
    title={title}
    panelClassName="max-w-6xl"
  >
    <div className="space-y-4">
      {summary ? (
        <section className="rounded-2xl border border-myteengig-border bg-myteengig-background/70 p-4">
          {summary}
        </section>
      ) : null}

      {scheduleProposalContent ? (
        <section className="rounded-2xl border border-myteengig-border bg-myteengig-background/70 p-4">
          {scheduleProposalContent}
        </section>
      ) : null}

      <section className="rounded-2xl border border-myteengig-border bg-white p-4">
        <GigRequestMessagesPanel
          requestId={requestId}
          role={role}
          participantLabel={participantLabel}
          description={messagesDescription}
          emptyMessage={emptyThreadMessage}
          centerHeader
          embedded
          proposals={proposals}
          timeZone={timeZone}
          perspective={perspective}
          sectionLabel="Conversation"
          secondaryAction={composerSecondaryAction}
          allowContactInfo={allowContactInfo}
        />
      </section>
    </div>
  </Modal>
);

export default GigRequestConversationModal;
